// extracted by css-extract-rspack-plugin
export default {"wrapper":"PpSvOM3dQUUsAzp5","input":"CMP39ZWFcXA7I5ec","text":"nR9uoMUSslke0CuH"};